import { render, staticRenderFns } from "./memberDetail.vue?vue&type=template&id=ecff91d4&"
import script from "./memberDetail.vue?vue&type=script&lang=js&"
export * from "./memberDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports